<template>
  <nav>
    <UiAnim type="b-50" id="menu">
      <div class="wrapper">
        <NuxtLink to="/" id="logo">
          <img alt="" src="/static/image/logo.png"
        /></NuxtLink>

        <MainMenuLinks />

        <span class="clr"></span>
        <ClientOnly>
          <button id="mobileMenuOpen" type="button" @click="mmo = true">
            <svg
              fill="#fff"
              width="24px"
              height="24px"
              viewBox="0 0 50 50"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M10 12h30v4H10z" />
              <path d="M10 22h30v4H10z" />
              <path d="M10 32h30v4H10z" />
            </svg>
          </button>
        </ClientOnly>
      </div>
    </UiAnim>
  </nav>
  <ClientOnly>
    <div id="mobileMenuBG" :class="{ show: mmo }" @click="mmo = false"></div>
    <div id="mobileMenu" :class="{ open: mmo }">
      <button id="mobileMenuClose" type="button" @click="mmo = false">
        <IconClose />
      </button>
      <MainMenuLinks :isMobile="true" @close="mmo = false" />
    </div>
  </ClientOnly>
</template>

<script setup>
const mmo = ref(false);
const esc = (e) => {
  if (e.keyCode == 27) mmo.value = false;
};
onMounted(() => document.addEventListener("keydown", esc));
onUnmounted(() => document.removeEventListener("keydown", esc));
</script>
